import { Github, Linkedin, Instagram, Mail, Heart } from "lucide-react";
import { useTranslation } from "react-i18next";

export const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="py-4 px-6 bg-primaryBg dark:bg-primaryBgDark text-primaryText dark:text-primaryTextDark flex items-center justify-between">
      <div className="flex items-center space-x-4">
        <a
          href="https://github.com/jobinjedison"
          target="_blank"
          rel="noopener noreferrer"
          className="text-primaryText dark:text-primaryTextDark hover:text-secondaryText hover:dark:text-secondaryTextDark transition-colors"
        >
          <Github size={20} />
        </a>
        <a
          href="https://www.linkedin.com/in/jobin-j-edison-3233633a0/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-primaryText dark:text-primaryTextDark hover:text-secondaryText hover:dark:text-secondaryTextDark transition-colors"
        >
          <Linkedin size={20} />
        </a>
        <a
          href="mailto:jedison.jobin@gmail.com"
          className="text-primaryText dark:text-primaryTextDark hover:text-secondaryText hover:dark:text-secondaryTextDark transition-colors"
        >
          <Mail size={20} />
        </a>
        <a
          href="https://www.instagram.com/jr_.edison/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-primaryText dark:text-primaryTextDark hover:text-secondaryText hover:dark:text-secondaryTextDark transition-colors"
        >
          <Instagram size={20} />
        </a>
      </div>

      <div className="flex items-center space-x-1 text-sm">
        <span>{t("Built with")}</span>
        <Heart
          size={16}
          className="inline mb-0.5 text-secondaryText dark:text-secondaryTextDark"
        />
        <span>{t("by")}</span>
        <span className="font-bold text-primaryText dark:text-primaryTextDark">
          Jobin J Edison
        </span>
      </div>
    </footer>
  );
};
